import React, { useState } from 'react';
import { useEffect } from 'react';
import GlbHdrUi from 'Views/Glb/GlbHdrUi';
import GlbFtrUi from 'Views/Glb/GlbFtrUi';
import {Outlet,useLocation, useNavigate} from 'react-router-dom';
import GameSubHdrUi from 'Views/Game/GameSubHdrUi';
import GameLandingHdrUi from 'Views/Game/GameLandingHdrUi';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import MgpStore from "Stores/Store";
import GameMainPageApi from 'Apis/GameMainPageApi';
import GameTstrApi from 'Apis/GameTstrApi';
import UseLangLstQuery from "Apis/LangTxtInqApi";
import ApiError from 'Utils/ApiError';
import ApiResultModal from 'Components/ApiResultModal';
import "Assets/css/GamePage.css";
const GameMainLayout = () => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    const location= useLocation();  
    let gameSvcCd:any;
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    if(getGameSvcCd != null){
        gameSvcCd = getGameSvcCd;
    }else {
        gameSvcCd = "bbo";
    }
    const [gameMainPageData,setGameMainData] = useState();
    const [isHdrFixed, setIsHdrFixed] = useState(false);
    const [mntnData, setMntnData] = useState<any>(null);
    const [tstrData, setTstrData] = useState<any>(null);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const isLandingRoute = /^\/landing\/?$/i.test(location.pathname);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    
    useEffect(()=>{
        IsMntnInqApi(gameSvcCd)
        .then((resp)=>{
            
            // 점검 데이터 저장
            setMntnData(resp.apiBody);
            
            // MGP 본체 점검 확인 (본체 점검 시 모든 페이지 차단)
            const mgpMntnInfo = resp.apiBody?.find((item: any) => item.gameSvcCd?.toUpperCase() === "MGP");
            
            
            if(mgpMntnInfo && mgpMntnInfo.isMntn === "Y") {
            
                return navigate("/mntn?gameSvcCd=MGP", { replace: true, state: { mntnData: resp.apiBody } });
            }
            
        });
        GameTstrApi(gameSvcCd).then((resp)=> {
            switch(resp.apiHdr.code){
                case "GAME0000":
                    setTstrData(resp.apiBody);
                    break;
                default:
                    ApiError(langData, resp.apiHdr.code);
                break;
            }
        })
        GameMainPageApi(gameSvcCd).then((resp)=> {
            setGameMainData(resp.apiBody);
            if(resp.apiBody.rlsYn === "N"){
                openResultModal("페이지 준비중입니다.", () => {
                    window.location.href = "/";
                });
            }
        })
    },[MgpStore.getState().LangSetState.Lang])
    return (
        <div className='rootContainer'>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData && langData.COMM_MAIN_CHK_MAIN_BTN_00}
            />
            <div className='gamePageWrap'>
                {isLandingRoute ? (
                    <GameLandingHdrUi gameSvcCd={gameSvcCd} gameMainPageData={gameMainPageData} onFixedChange={setIsHdrFixed} mntnData={mntnData} tstrData={tstrData} />
                ) : (
                    <GameSubHdrUi gameSvcCd={gameSvcCd} gameMainPageData={gameMainPageData} onFixedChange={setIsHdrFixed} mntnData={mntnData} tstrData={tstrData} />
                )}
                <div style={{ marginTop: isHdrFixed ? parseInt(process.env.REACT_APP_GLOBAL_HEADER_HEIGHT || "50") : 0 }}>
                    <Outlet  context={{gameMainPageData, langData, mntnData, tstrData}}/>
                </div>
                <GlbFtrUi  gameSvcCd={gameSvcCd} gameMainPageData={gameMainPageData&&gameMainPageData}/>
            </div>
        </div>
    );
  }
  export default GameMainLayout;